import { Component, Input, OnInit } from "@angular/core";
import {
  JobSettingsViewModel,
  MediaItemTranscodeSettingVM,
} from "../job-settings.view-model";
import { MediaItem } from "../../../../../domain/media";

@Component({
  selector: "evrideo-media-files-landzone",
  templateUrl: "./media-files-landzone.component.html",
  styleUrls: ["./media-files-landzone.component.scss"],
})
export class MediaFilesLandzoneComponent implements OnInit {
  @Input()
  vm: JobSettingsViewModel;

  constructor() {}

  ngOnInit() {}
}
